import axios from "axios";
import {
  apiInstanceWithAccessToken,
  apiInstanceWithStaticToken,
} from "./baseUrl";

const symptomURL =
  "https://mcd-data-api.myprognosis.ai/api/v1/symptoms/completions";
export const symtomChat = async (dataset) => {
  try {
    const response = await axios.post(
      symptomURL,
      {
        dataset,
      },
      {
        responseType: "stream",
      }
    );
    let data = "";
    console.log(response);
    response.data.on("data", (chunk) => {
      // Handle each chunk of streaming data here
      data += chunk;
    });
    response.data.on("end", () => {
      // Handle the end of streaming data here
      return data; // Update state with the streaming data
    });
  } catch (error) {
    // throw new Error("Failed to fetch API");
    console.error("Error fetching data:", error);
    return error;
  }
};

// <---- consumerApiWithStaticToken Start ---->

export const sendOtp = async (dataset) => {
  try {
    const response = await apiInstanceWithStaticToken.post(
      "consumer/auth/otp/send",
      dataset
    );
    return response?.data;
  } catch (error) {
    console.error("Error:", error);
    return error?.response;
  }
};
export const verifyOtp = async (dataset) => {
  try {
    const response = await apiInstanceWithStaticToken.post(
      "consumer/auth/otp/verify",
      dataset
    );
    return response.data;
  } catch (error) {
    console.error("Error:", error);
  }
};
export const uploadAvatar = async (dataset) => {
  try {
    const response = await apiInstanceWithStaticToken.post(
      "consumer/avatar/upload",
      dataset,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error:", error);
  }
};

export const consumerRegister = async (payload) => {
  try {
    const response = await apiInstanceWithStaticToken.post(
      `consumer/register`,
      payload
    );
    return response.data;
  } catch (error) {
    console.error("Error:", error);
    return error?.response;
  }
};

export const getConsumerDetailWithStaticToken = async (id) => {
  try {
    const data = await apiInstanceWithStaticToken.get(`consumer/${id}`);
    return data?.data;
  } catch (error) {
    return error;
  }
};

export const consumerDeletion = async (id) => {
  try {
    const response = await apiInstanceWithStaticToken.delete(`consumer/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error:", error);
    return error?.response;
  }
};

// <---- consumerApiWithStaticToken End ---->

// <---- consumerAccessToken Start ---->

export const getConsumerDetail = async (id) => {
  try {
    const data = await apiInstanceWithAccessToken.get(`consumer/cr/${id}`);
    return data?.data;
  } catch (error) {
    return error;
  }
};

export const uploadDocument = async (dataset) => {
  try {
    const response = await apiInstanceWithAccessToken.post(
      "consumer/upload",
      dataset,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error:", error);
  }
};

export const updateProfile = async (user_id, dataset) => {
  try {
    const response = await apiInstanceWithAccessToken.put(
      `consumer/${user_id}`,
      dataset,
      {
        headers: {
          "Content-Type": "application/json",
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error:", error);
  }
};

export const getDocuments = async (query) => {
  try {
    const data = await apiInstanceWithAccessToken.get(`consumer/upload`, {
      params: {
        type: query?.type,
        consumer_id: query?.patientId,
        start_date: query?.startDate,
        end_date: query?.endDate,
      },
    });
    return data?.data;
  } catch (error) {
    return error;
  }
};

export const getDocumentsAvailableRange = async (
  patientId,
  limit,
  doc_type
) => {
  try {
    const data = await apiInstanceWithAccessToken.get(
      `consumer/documents/available-range`,
      {
        params: {
          consumer_id: patientId,
          doc_type: doc_type,
          limit: limit,
        },
      }
    );
    return data?.data;
  } catch (error) {
    return error;
  }
};

export const getVitalsAvailableRange = async (payload) => {
  try {
    const { patientId, limit } = payload;
    const data = await apiInstanceWithAccessToken.get(
      `consumer/vitals/available-range`,
      {
        params: {
          consumer_id: patientId,
          limit: limit,
        },
      }
    );
    return data?.data;
  } catch (error) {
    return error;
  }
};

export const getVitals = async (queryParams) => {
  try {
    const data = await apiInstanceWithAccessToken.get(`consumer/vitals`, {
      params: {
        consumer_id: queryParams?.patientId,
        start_date: queryParams?.startDate,
        end_date: queryParams?.endDate,
      },
    });
    return data?.data;
  } catch (error) {
    return error;
  }
};

export const postVitals = async (payload) => {
  try {
    const data = await apiInstanceWithAccessToken.post(
      `consumer/vitals`,
      payload
    );
    return data?.data;
  } catch (error) {
    return error;
  }
};

export const updateVitals = async (vitalId, payload) => {
  try {
    const data = await apiInstanceWithAccessToken.put(
      `vitals/${vitalId}`,
      payload
    );
    return data?.data;
  } catch (error) {
    return error;
  }
};

export async function getVitalsReference() {
  const url = `vitals/reference`;
  try {
    const res = await apiInstanceWithAccessToken.get(`consumer/${url}`);
    return res?.data;
  } catch (error) {
    // throw new Error("Failed to fetch API");
    return error;
  }
}

export async function getVitalsTrends(id, params) {
  const url = `vitals/trends/${id}`;
  try {
    const response = await apiInstanceWithAccessToken.get(`consumer/${url}`, {
      params: params,
    });
    return response.data;
  } catch (error) {
    console.error("There was a problem with the fetch operation:", error);
  }
}

export const shareVitals = async (payload) => {
  try {
    const data = await apiInstanceWithAccessToken.post(
      `consumer/vitals/share`,
      payload,
      {
        params: {
          vitals_id: payload?.vitals_id,
          organization_id: payload?.organization_id,
        },
      }
    );
    return data?.data;
  } catch (error) {
    return error;
  }
};

export const shareDocument = async (payload) => {
  try {
    const data = await apiInstanceWithAccessToken.post(
      `consumer/document/share`,
      payload,
      {
        params: {
          document_id: payload?.document_id,
          shared_with: payload?.shared_with,
          organization_id: payload?.organization_id,
          permissions: {
            read: true,
            write: false,
            share: false,
            delete: false,
          },
          is_active: true,
        },
      }
    );
    return data?.data;
  } catch (error) {
    return error;
  }
};

export const getOrganizations = async (user_id) => {
  try {
    const response = await apiInstanceWithAccessToken.get(
      `consumer/organizations/${user_id}`
    );
    return response.data;
  } catch (error) {
    console.error("Error:", error);
  }
};

export const updateOrganizations = async (user_id, dataset) => {
  try {
    const response = await apiInstanceWithAccessToken.put(
      `consumer/organizations/${user_id}`,
      dataset
    );
    return response.data;
  } catch (error) {
    console.error("Error:", error);
  }
};

export const deleteOrganizations = async (user_id, org_id) => {
  try {
    const response = await apiInstanceWithAccessToken.delete(
      `consumer/organizations/${user_id}/${org_id}`
    );
    return response.data;
  } catch (error) {
    console.error("Error:", error);
  }
};

export const getStreamDocument = async (queryParams) => {
  try {
    const data = await axios.get(
      `${process.env.REACT_APP_API_BASEURL}/api/v1/consumer/ecg-stream-document/${queryParams.doc_id}`,
      {
        responseType: "blob",
        headers: {
          ConsumerID: queryParams.consumer_id,
        },
      }
    );
    return data?.data;
  } catch (error) {
    return error;
  }
};

// <---- admin api start ---->
const adminApiInstance = axios.create({
  baseURL: `${process.env.REACT_APP_API_BASEURL}/api/v1/consumer`,
});
export const userlist = async () => {
  try {
    let adminAccessToken = sessionStorage.getItem("adminAccessToken");
    const data = await adminApiInstance.get(``, {
      headers: { Authorization: `Bearer ${adminAccessToken}` },
    });
    return data;
  } catch (error) {
    return error;
  }
};

export const shareUrl = async (payload) => {
  try {
    let adminAccessToken = sessionStorage.getItem("adminAccessToken");
    const data = await adminApiInstance.post(`share`, payload, {
      headers: { Authorization: `Bearer ${adminAccessToken}` },
    });
    return data;
  } catch (error) {
    return error;
  }
};

export const adminUploadDocument = async (dataset) => {
  try {
    let adminAccessToken = sessionStorage.getItem("adminAccessToken");
    const response = await adminApiInstance.post("upload", dataset, {
      headers: {
        Authorization: `Bearer ${adminAccessToken}`,

        "Content-Type": "multipart/form-data",
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error:", error);
  }
};

// <---- admin api end ---->

// <---- user api start ---->

// const userApiInstance = axios.create({
//   baseURL: `${process.env.REACT_APP_API_BASEURL}/api/v1/user`,
//   headers: {
//     "Content-Type": "application/json",
//     Authorization: `Bearer ${process.env.REACT_APP_STATICACCESSTOKEN}`,
//   },
// });
export const accessadmin = async (payload) => {
  try {
    const data = await apiInstanceWithStaticToken.post(
      `user/login/passcode`,
      payload
    );
    return data;
  } catch (error) {
    return error;
  }
};
export const specialityList = async () => {
  try {
    const data = await apiInstanceWithStaticToken.get(`user/speciality`);
    return data?.data;
  } catch (error) {
    return error;
  }
};
export const getUser = async (queryParams) => {
  try {
    const data = await apiInstanceWithStaticToken.get(`user`, {
      params: queryParams,
    });
    return data?.data;
  } catch (error) {
    return error;
  }
};
export const getPhysicians = async (queryParams) => {
  try {
    const data = await apiInstanceWithStaticToken.get(`user/physicians`, {
      params: queryParams,
    });
    return data?.data;
  } catch (error) {
    return error;
  }
};
export const getUserDetails = async (queryParams) => {
  try {
    const data = await apiInstanceWithStaticToken.get(`user/all-details`, {
      params: queryParams,
    });
    return data?.data;
  } catch (error) {
    return error;
  }
};

// <---- user api end ---->

// <---- organization api start ---->

// const organizationApiInstance = axios.create({
//   baseURL: `${process.env.REACT_APP_API_BASEURL}/api/v1/organization`,
//   headers: {
//     "Content-Type": "application/json",
//     Authorization: `Bearer ${process.env.REACT_APP_STATICACCESSTOKEN}`,
//   },
// });

export const locationsList = async () => {
  try {
    const data = await apiInstanceWithStaticToken.get(`organization/locations`);
    return data?.data;
  } catch (error) {
    return error;
  }
};

export const getHospitals = async (queryParams) => {
  try {
    const data = await apiInstanceWithStaticToken.get(`organization`, {
      params: queryParams,
    });
    return data?.data;
  } catch (error) {
    return error;
  }
};

// <---- organization api end ---->

// <---- appointments api start ---->

export const getAvailDates = async (queryParams) => {
  try {
    const data = await apiInstanceWithAccessToken.get(
      `appointments/user/available-dates`,
      {
        params: queryParams,
      }
    );
    return data?.data;
  } catch (error) {
    return error;
  }
};
export const getAvailSlots = async (queryParams) => {
  try {
    const data = await apiInstanceWithAccessToken.get(
      `appointments/user/available-slots`,
      {
        params: queryParams,
      }
    );
    return data?.data;
  } catch (error) {
    return error;
  }
};
export const scheduleAppointment = async (payload) => {
  try {
    const data = await apiInstanceWithAccessToken.post(`appointments`, payload);
    return data?.data;
  } catch (error) {
    return error;
  }
};
export const updateAppointmentStatus = async (id, payload) => {
  try {
    const data = await apiInstanceWithAccessToken.put(
      `appointments/${id}`,
      payload
    );
    return data?.data;
  } catch (error) {
    return error;
  }
};
export const getAppointments = async (queryParams) => {
  try {
    const data = await apiInstanceWithAccessToken.get(`appointments`, {
      params: queryParams,
    });
    return data?.data;
  } catch (error) {
    return error;
  }
};
export const getPastAppointments = async (queryParams) => {
  try {
    const data = await apiInstanceWithAccessToken.get(`appointments/past`, {
      params: queryParams,
    });
    return data?.data;
  } catch (error) {
    return error;
  }
};
export const getUpcomingAppointments = async (queryParams) => {
  try {
    const data = await apiInstanceWithAccessToken.get(`appointments/upcoming`, {
      params: queryParams,
    });
    return data?.data;
  } catch (error) {
    return error;
  }
};
export async function sendSms(appointment_id) {
  // const url ="https://q3xghsviczze56qqikn3757rvy0mdayd.lambda-url.us-east-1.on.aws/";
  // const url ="https://ly4r3e57e8.execute-api.us-east-1.amazonaws.com/dev/send-sms";
  const url = `appointments/consumer/join/${appointment_id}`;
  try {
    const data = await apiInstanceWithAccessToken.post(url, {});
    return data;
  } catch (error) {
    return error;
  }
}

export const sendJoinSms = async (appointment_id) => {
  try {
    const data = await apiInstanceWithStaticToken.post(
      `appointments/consumer/join/${appointment_id}`,
      {}
    );
    return data?.data;
  } catch (error) {
    return error;
  }
};
export const getUnAuthAppointments = async (queryParams) => {
  try {
    const data = await apiInstanceWithStaticToken.get(
      `appointments/user-un-auth`,
      {
        params: queryParams,
      }
    );
    return data?.data;
  } catch (error) {
    return error;
  }
};
export const updateUnAuthAppointmentsStatus = async (
  appointment_id,
  payload
) => {
  try {
    const data = await apiInstanceWithStaticToken.put(
      `appointments/${appointment_id}/user-un-auth`,
      payload
    );
    return data?.data;
  } catch (error) {
    return error;
  }
};
// <---- appointments api end ---->

// <---- generic api start ---->
export const getGenericMiscellaneous = async (queryParams) => {
  try {
    const data = await apiInstanceWithStaticToken.get(`generic/miscellaneous`, {
      params: queryParams,
    });
    return data?.data;
  } catch (error) {
    return error;
  }
};
export const decryptUrl = async (url) => {
  try {
    const data = await apiInstanceWithStaticToken.post(`generic/hash/content`, {
      hash: url,
      base_url: "https://app.myprognosis.ai",
    });
    return data?.data;
  } catch (error) {
    return error;
  }
};
// <---- generic api end ---->

export async function createRoom(payload) {
  // const exp = Math.round(Date.now() / 1000) + 60 * 30;
  // const options = {
  //   properties: {
  //     exp,
  //     enable_prejoin_ui: false, // TODO: remove me when robots are no longer needed
  //   },
  // };
  const dailycoToken = `ec6209696875bcb1181d5900e3d1c778485fb3d91265cbd66d36cf6c50303c31`;
  const options = {
    // name:payload.name,
    properties: {
      enable_chat: true,
      // exp: Math.floor(Date.now() / 1000) + 86400,
      exp: payload?.end_time
        ? payload.end_time
        : Math.floor(Date.now() / 1000) + 86400,
      nbf: payload?.start_time
        ? payload.start_time
        : Math.floor(Date.now() / 1000),
      start_audio_off: true,
      start_video_off: true,
    },
  };

  /*
      This endpoint is using the proxy as outlined in netlify.toml.
      Comment this out if you want to use the local option below.
    */
  // const response = await fetch(`${window.location.origin}/api/rooms`, {
  //   method: "POST",
  //   body: JSON.stringify(options),
  // });

  /*
      Uncomment the request below to test the "create room" functionality locally.
      Don't forget to comment out the request above, too!
    */
  const response = await fetch("https://api.daily.co/v1/rooms/", {
    method: "POST",
    body: JSON.stringify(options),
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${dailycoToken}`,
      // Authorization: 'Bearer ' + process.env.REACT_APP_DAILY_API_KEY,
    },
  });

  return await response.json();
}
